'use client';

import * as React from 'react';
import classNames from 'classnames';
import Icon, { IconsAvailable } from '@/components/ui/Icon';
import Button, { IButtonProps } from '@/components/ui/Button';
import './styles.scss';

export interface IDetailsProps {
  prefix?: React.ReactNode;
  title: React.ReactNode;
  titleExpanded?: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  open?: boolean;
  onToggle?: () => void;
  layout?: 'default' | 'compact';
  buttons?: IButtonProps[];
}

const Details: React.FC<IDetailsProps> = ({ open: controlledOpen, onToggle, defaultOpen = false, ...props }) => {
  const isControlled = typeof controlledOpen === 'boolean';
  const [uncontrolledOpen, setUncontrolledOpen] = React.useState(defaultOpen);
  const open = isControlled ? controlledOpen : uncontrolledOpen;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (isControlled) {
      onToggle?.();
    } else {
      setUncontrolledOpen((prev) => !prev);
    }
  };

  let title = props.title;

  if (props.titleExpanded && open) {
    title = props.titleExpanded;
  }

  let arrows: [IconsAvailable, IconsAvailable] = ['close', 'add'];

  if (props.layout === 'compact') {
    arrows = ['arrow03-up', 'arrow03-down'];
  }

  return (
    <details
      className={classNames('details', {
        ['layout-default']: props.layout === 'default' || !props.layout,
        ['layout-compact']: props.layout === 'compact',
      })}
      open={open}
    >
      <summary onClick={handleClick}>
        <Icon
          width={24}
          height={24}
          kind={open ? arrows[0] : arrows[1]}
        />
        <div className={'details__text'}>
          {props.prefix && <div className={'details__prefix'}>{props.prefix}</div>}
          <div className={'details__title'}>{title}</div>
        </div>
        {props.buttons && props.buttons.length > 0 && (
          <div className={'details__buttons'}>
            {props.buttons.map((b, bi) => (
              <Button
                key={bi}
                {...b}
                size="small"
              />
            ))}
          </div>
        )}
      </summary>
      {open && <div className={'details__content'}>{props.children}</div>}
    </details>
  );
};

Details.displayName = 'Details';

export default Details;
